<template>
	<div class="container-fluid">
	    <div class="m-2">
	    	<div class="row d-flex justify-content-center">
	    		<div class="col-12">
	    			<div class="row">
	    				<div class="col-12">
	    					<div class="alert alert-primary">
	    						<div class="h4 text-center">
	    							<linkto :link="'/products'"/>
	    							Termék módosítás
	    						</div>
	    					</div>
	    				</div>
	    			</div>
	    			<div class="row d-flex justify-content-center align-items-center">
	    				<productdata
	    					:change="true"
	    					:id="$route.params.id"
	    				>
	    				</productdata>
	    			</div>
	    		</div>
	    	</div>
	    </div>
	</div>
</template>

<script>
import productdata from './product_data'
export default {
  name: 'type',
  components: {
  	productdata
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/products/product.vue